import {
  OPEN_TASK_PROJECT_STATUSES,
  TASK_PROJECT_STATUS_LABELS,
  TaskProjectStatus,
} from '../../interfaces/taskProject'
import { FilterFieldType, IFilter } from './types'

export const TASK_PROJECT_STATUS_OPTIONS = Object.values(TaskProjectStatus).map((status) => ({
  value: status,
  label: TASK_PROJECT_STATUS_LABELS[status],
}))

export const PROJECTS_ACTIVE_QUICK_FILTER = 'Active'

// Search/filter config for the projects overview list — mirrors the My Tasks
// filter bar. `name` and `status` are plain column filters (buildFiltersQuery).
// `members` is a many-to-many relation, not a column, so it's marked `isCustom`
// (skipped by buildFiltersQuery) and resolved server-side via an EXISTS on the
// membership table in ListProjects.
export const PROJECTS_LIST_FILTERS_CONFIG = [
  {
    type: FilterFieldType.QuickFilter,
    field: 'quickFilter',
    quickFilters: [
      {
        title: PROJECTS_ACTIVE_QUICK_FILTER,
        filters: { status: [...OPEN_TASK_PROJECT_STATUSES] },
      },
    ],
  },
  {
    field: 'name',
    type: FilterFieldType.Text,
    dbField: 'name',
    alias: 'project',
    isSortable: true,
    title: 'Name',
    placeholder: 'Project name',
  },
  {
    field: 'status',
    type: FilterFieldType.List,
    dbField: 'status',
    alias: 'project',
    isSortable: true,
    isMultiple: true,
    title: 'Status',
    options: TASK_PROJECT_STATUS_OPTIONS,
  },
  {
    field: 'memberIds',
    type: FilterFieldType.Autocomplete,
    isCustom: true,
    isMultiple: true,
    isSortable: false,
    title: 'Members',
    placeholder: 'Members',
  },
] as const satisfies IFilter[]
